import LoginCancelamento from "./loginCancelamento";
import {connect} from "react-redux";

export default connect()(LoginCancelamento);
